import { ApiCore } from './utilities/core'


export const zendeskTicketDetailsAPI = (tenantSlug: string) => {
    return new ApiCore({
        getSingle: true,
        url: `api/${tenantSlug}/zendesk`
    })
};